<template>
  <ul
    v-if="getSettingsList.length"
  >
    <ActionSettingsItem
      v-for="(setting, index) in getSettingsList"
      :key="index"
      :setting="setting"
      @changeStorageSettings="changeStorageSettings"
    />
  </ul>
  <div
    v-else
    class="settings-empty"
  >
    None saved. Click "Share icon" to save current settings.
  </div>
</template>

<script>
import ActionSettingsItem from '@/widgets/common/ActionSettingsItem'
export default {
  name: 'ActionSettingsList',
  components: {
    ActionSettingsItem
  },
  props: {
    settingsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getSettingsList() {
      return this.settingsList
    }
  },
  methods: {
    changeStorageSettings(value) {
      this.$emit('changeStorageSettings', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.settings-empty {
  font-size: 14px;
  display: flex;
  height: 100px;
  align-items: center;
  color: #6c7683;
}
</style>
